import styled from 'styled-components';

/* ------------------------- StyleTokenSection -------------------------- */

/**
 * StyledTokenField
 *
 * Styled input field
 */
export const StyledTokenFieldBlock = styled.input(
    ({ theme }) => `
    display: inline;
    outline: none;
    text-align: center;
    text-transform: uppercase;
    transition: 0.1s;
    background: ${theme.sections.page.background};
    border: 0.1rem solid ${theme.sections.page.feature};
    color: ${theme.sections.page.a};
    border-radius: 0.5rem;
    font-weight: bold;

    margin: 0 0.3rem;
    font-size: 1rem;
    padding: 0.7em 0;
    max-width: 2.5em;

    @media (min-width: 972px) {
        font-size: 1.5rem;
        margin: 0 0.4rem;
        font-size: 2.5rem;
        padding: 0.4em 0;
        max-width: 2em;
    }

    &:focus {
        transform: scale(1.2);
    }
`,
);
